import React from "react";

const CustomPagination = ({ rowsPerPage, rowCount, onChangePage, currentPage, leftContent }) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onChangePage(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // First page
    if (startPage > 1) {
      pageNumbers.push(
        <li
          key={1}
          className="page-item"
          onClick={() => handlePageClick(1)}
          style={{ cursor: "pointer" }}
        >
          <span className="page-link">1</span>
        </li>
      );
      if (startPage > 2) {
        pageNumbers.push(
          <li key="ellipsis-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
          onClick={() => handlePageClick(i)}
          style={{ cursor: "pointer" }}
        >
          <span 
            className="page-link"
            style={currentPage === i ? { backgroundColor: "#c59253", borderColor: "#c59253", color: "white" } : {}}
          >
            {i}
          </span>
        </li>
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <li key="ellipsis-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pageNumbers.push(
        <li
          key={totalPages}
          className="page-item"
          onClick={() => handlePageClick(totalPages)}
          style={{ cursor: "pointer" }}
        >
          <span className="page-link">{totalPages}</span>
        </li>
      );
    }

    return pageNumbers;
  };

  // If only 1 page, show only leftContent without pagination controls
  if (totalPages <= 1) {
    return leftContent ? (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="pagination-left-content">
          {leftContent}
        </div>
      </div>
    ) : null;
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="pagination-left-content">
        {leftContent}
      </div>
      <ul className="pagination mb-0">
        {/* Previous Button */}
        <li
          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => handlePageClick(currentPage - 1)}
          style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
        >
          <span className="page-link">
            <i className="ri-arrow-left-s-line"></i>
          </span>
        </li>

        {/* Page Numbers */}
        {renderPageNumbers()}

        {/* Next Button */}
        <li
          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
          onClick={() => handlePageClick(currentPage + 1)}
          style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
        >
          <span className="page-link">
            <i className="ri-arrow-right-s-line"></i>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default CustomPagination;

